import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, Typography } from "@mui/material";
import { getRegistration } from "redux/actions/UserRegistration";
import { getServiceCity } from "redux/actions/UserServiceCity";
import CommonForm from "components/commonForm/CommonForm";
import login_hand from "assets/images/login_hand.png";
import logo from 'assets/images/companyLogo.svg';
import { companyDetails } from "utils/companyDetails";
import { getBranding } from "config/tenantConfig";

export default function Signup() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userRegistration = useSelector((state) => state);
  const isLoader = userRegistration?.userRegistration?.loading;
  const location = useSelector((state) => state?.userServiceCity?.userServiceCity?.data);
  const locationOption = location?.map((val, idx) => {
    return { value: val?.id, label: val?.name };
  });

  const handleredirect = () => {
    navigate('/')
  }

  useEffect(() => {
    dispatch(getServiceCity())
  }, [])


  const registrationForm = [
    {
      placeholder: "Company name",
      required: true,
      type: "text",
      name: "companyname",
      label: "Company Name",
    },
    {
      placeholder: "Email",
      required: true,
      type: "text",
      name: "email",
      label: "Email",
    },
    {
      placeholder: "Mobile Number",
      required: true,
      type: "text",
      name: "number",
      label: "Mobile Number",
      countrycode: true,
    },
    {
      singleAutoComplete: true,
      placeholder: "Choose location",
      required: true,
      type: "text",
      name: "location",
      label: "Location",
      singleOptions:locationOption
    },
  ];
  

  const onSignup = (data, code) => {
  // dispatchEvent(call redux function: action -> saga -> reducer (update the store)
    const signupPayload = {
      userDetails: {
        platform: 'AdminApp',
        mobile: data.number,
        email: data.email,
        countryCode: '+91',
        location: data.location,
        companyName: data.companyname,
        role:'subVendor'
        },
    actionType: "signup"
  }

  localStorage.setItem('registered', true);
  dispatch(getRegistration(signupPayload, navigate));
};

  return (
    <div>
      <Box sm={{ flexGrow: 1 }} className="subVendormobileRes">
        <Grid container>
          {/* ---login Part--- */}
          <Grid item sm={6}>
            {/* ---login nav--- */}
            <Box
              sx={{display: { xs: 'none', sm: 'flex' },
                    alignItems: 'center',
                  }}
                  className="positionAbsolute"
                >
                  <img src={getBranding().logo || companyDetails?.companyLogo} className="logoImg" alt="otplogo" />
                </Box>
            {/* ---login input type--- */}
            <div className="subVendorloginInput subVendormobileBg">
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                rowSpacing={4}
              >
                <Grid item sm={10} sx={{ textAlign: 'center' }} className="">
                  <img src={login_hand} alt="hand" />
                  <Typography className="fontBold font36 colorBlue">
                  Let's get started as <span className="colorYellow">Sub-Vendor</span>
                  </Typography>
                  <Typography className="font18 fontNormal colorGrey">Add your registration details below</Typography>
                </Grid>
                <Grid item sm={7} className="">
                  <CommonForm
                    formData={registrationForm}
                    button={'Sign Up'}
                    onSubmittBtn={onSignup}
                    loading={isLoader}
                  />
                </Grid>
              </Grid>
              <Typography className="colorGrey font18 fontNormal marginTop">Already have an account ?<span className="colorBlue cursor" onClick={handleredirect}> Login now</span></Typography>
            </div>
          </Grid>
          {/* ---Image Part--- */}
          <Grid item sm={6} sx={{ display: { xs: 'none', sm: 'flex' }}} className="bgImage">
            <div className="subvendorloginBgImg"></div>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
